// style overrides for mui datagrid to match out design needs
export const tableStyleOverrides = {
  '&.MuiDataGrid-root': {
    outline: 'none !important',
    border: 'none !important',
    backgroundColor: '#ffffff',
  },
  '&.MuiDataGrid-root .MuiDataGrid-cell': {
    outline: 'none !important',
    fontStyle: 'normal',
  },
  '&.MuiDataGrid-root .MuiDataGrid-columnHeaderTitleContainer': {
    padding: 0,
  },
  '.MuiDataGrid-columnHeaderTitle': {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '24px',
    letterSpacing: '0.17px',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  '.MuiTablePagination-root .MuiTablePagination-selectLabel': {
    color: 'rgba(0, 0, 0, 0.6) !important',
  },
  '&.MuiDataGrid-root .MuiDataGrid-actionsCell .MuiSvgIcon-root': {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '24px',
  },
  '.MuiDataGrid-overlay': {
    height: 'auto !important',
  },
};

export const tableStyleHideSeparator = {
  '& .MuiDataGrid-iconSeparator': {
    display: 'none',
  },
};
